export default __webpack_public_path__ + "static/media/noprofile.1e7b0411.svg";